export const SetUID = 'set_uid';
export const Subscribe = 'subscribe';
export const Unsubscribe = 'unsubscribe';
export const Push = 'push';
export const Update = 'update';
export const Remove = 'remove';
export const PushFile = 'push_file';
export const RemoveFile = 'remove_file';
export const RemoveFiles = 'remove_files';
